<div mat-dialog-title *ngIf="actionButton != 'Export'">
  {{ canvasType }} Information
</div>
<div mat-dialog-title *ngIf="actionButton == 'Export'">
  What's the purpose of this {{ canvasType }}?
</div>

<form [formGroup]="detailForm">
  <div mat-dialog-content>
    <label>{{ canvasType }} Title<span class="requiredAsterix">*</span></label>
    <mat-form-field style="margin-left: 5px; width: 98%" appearance="fill">
      <input
        matInput
        placeholder="Enter a title for the {{ canvasType }}"
        name="title"
        id="title"
        maxlength="100"
        formControlName="title"
        required
      />
      <mat-error *ngIf="detailForm.get('title')?.hasError('required')">This field is required</mat-error>
      <mat-error *ngIf="detailForm.get('title')?.hasError('whitespace')">Title cannot be empty or whitespace</mat-error>
    </mat-form-field>
    <BR />
    <label
      >{{ canvasType }} Category<span class="requiredAsterix">*</span></label
    >
    <mat-form-field style="margin-left: 5px; width: 98%" appearance="fill">
      <mat-select
        formControlName="module_id"
        name="category"
        id="category"
        required
        [disabled]="!showCategory"
      >
        <mat-option *ngFor="let category of categories" [value]="category.id">
          {{ category.name }}
        </mat-option>
      </mat-select>
      <mat-error>This field is required</mat-error>
    </mat-form-field>

    <label
      >{{ canvasType }} Description<span class="requiredAsterix">*</span></label
    >
    <mat-form-field
      style="margin-left: 5px; width: 98%"
      appearance="fill"
      class="textarea"
    >
      <textarea
        matInput
        id="description"
        formControlName="description"
        #description
        placeholder="Describe the {{ canvasType }}"
        name="description"
        id="description"
        maxlength="200"
      ></textarea>
      <mat-error *ngIf="detailForm.get('description')?.hasError('required')">This field is required</mat-error>
      <mat-error *ngIf="detailForm.get('description')?.hasError('whitespace')">Description cannot be empty or whitespace</mat-error>
    </mat-form-field>
    <span>{{ description.value.length }} of 200 character limit</span>
    <BR />
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close class="button_small cancel">
      cancel
    </button>
    <button
      mat-button
      class="button_small"
      id="createReport"
      (click)="modifyDetails()"
      tabindex="-1"
      [disabled]="!detailForm.valid"
    >
      {{ actionButton }}
    </button>
  </div>
</form>
